import type { ButtonProps } from '../Button';

type ToggleButtonSize = NonNullable<ButtonProps['size']>;

/**
 * Per-size icon glyph sizes from the Figma "Toggle Icon button" set —
 * deliberately LARGER than Button's `ICON_SIZE_FOR` ramp (the toggle chips
 * are icon-only, so the glyph carries the whole affordance). Measured on the
 * Default/Outlined/Resting node per size; `xxl` extrapolated (+2 step) —
 * the Figma xxl node nests a broken legacy instance.
 */
export const TOGGLE_ICON_SIZE_FOR: Record<ToggleButtonSize, number> = {
  xxs: 14,
  xs: 16,
  s: 18,
  m: 20,
  l: 22,
  xl: 24,
  xxl: 26,
};

/**
 * Selected-state icon tint for NATIVE, where react-native-svg can't resolve
 * `currentColor` (web inherits `text-primary-800` from the container class
 * instead — including inside section-scoped dark stories). Light =
 * primary-800; dark = its CSS-var mirror shade primary-200 (dark shade =
 * 1000 − light shade). Hexes from `shared/src/ui/styles/brand-colors.json`.
 */
export const TOGGLE_SELECTED_ICON_COLOR = {
  light: '#5d0ec0',
  dark: '#ddd6ff',
} as const;
